import { Link } from 'react-router-dom';

import { LogoTheme, Size } from '../../constants';
import { getLogoSizeClasses, getLogoStyleClasses } from './constants';

import { useCallback } from 'react';
import { User } from 'referral-types';
import { useAuth } from '../../context/auth/useAuth';
import { getUserHomePageUrl } from '../user/user.constants';
import { LogoMark } from './LogoMark';

export const Logo = (props: Props) => {
  const { size, textColorOverride, iconColorOverride, theme, className, variant = 'filled', options = {} } = props;
  const { currentUser } = useAuth();
  const backUpLink = currentUser ? getUserHomePageUrl(currentUser) : '/';
  const { excludeLink, customLink } = options;
  const { iconSizeClasses } = getLogoSizeClasses(size);
  const { primaryTextColorClass, mainTextColorClass } = getLogoStyleClasses(theme);
  const iconColor = iconColorOverride || primaryTextColorClass;
  const textColor = textColorOverride || mainTextColorClass;

  const Contents = useCallback(
    () => (
      <LogoMark
        variant={variant}
        className={iconSizeClasses}
        bookClassName={iconColor}
        letterClassName={textColor}
      />
    ),
    [variant, iconSizeClasses, iconColor, textColor]
  );

  return excludeLink ? (
    <Contents />
  ) : (
    <Link className={className} to={customLink ? customLink : backUpLink}>
      <Contents />
    </Link>
  );
};

type Props = {
  size: Size;
  theme: LogoTheme;
  variant?: 'cutout' | 'filled';
  textColorOverride?: string;
  iconColorOverride?: string;
  options?: LogoOptions;
  className?: string;
  user?: User;
};

type LogoOptions = {
  excludeLink?: boolean;
  customLink?: string;
};
